"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventTests = void 0;
var __1 = require("../../..");
function eventTests(utils) {
    var loadEventsInput = utils.loadEventsInput, IDs = utils.IDs;
    var eventTestsInput = function () { return cy.get("#".concat(IDs.eventsInputID)); };
    var eventValue = function () { return cy.get("#".concat(IDs.eventsValueID)); };
    var mainEventName = function () { return cy.get("#".concat(IDs.eventsMainNameID)); };
    var altEventName = function () { return cy.get("#".concat(IDs.eventsAltNameID)); };
    var hasValue = function (value) { return function () { return eventValue().should('have.text', value).then(eventTestsInput); }; };
    var hasName = function (name) { return function () { return mainEventName().should('have.text', name).then(eventTestsInput); }; };
    var hasAltName = function (name) { return function () { return altEventName().should('have.text', name).then(eventTestsInput); }; };
    var keyDown = function () { return eventTestsInput().trigger('keydown', { key: 'ArrowUp' }); };
    var keyUp = function () { return eventTestsInput().trigger('keyup', { key: 'ArrowUp' }); };
    var mouseDown = function () { return eventTestsInput().trigger('mousedown'); };
    var mouseUp = function () { return eventTestsInput().trigger('mouseup'); };
    describe('Events', function () {
        it('ensures events work', function () {
            loadEventsInput()
                .then(hasValue(__1.staticValues.defaultValue.inputValue))
                .then(hasName('none'))
                .then(hasAltName('none'))
                .focus()
                .then(hasValue('08:30 PM'))
                .then(hasName('focus'))
                .then(hasAltName('none'))
                .then(keyDown)
                // Due to the event getting fired before the state has settled, the value is out of sync with the state
                // It is out of scope to adjust the timing of all possible events so that they align with when the state updates
                .then(hasValue('08:30 PM'))
                .then(hasName('keyDown'))
                .then(hasAltName('change'))
                .then(keyUp)
                .then(hasValue('09:30 PM'))
                .then(hasName('keyUp'))
                .then(hasAltName('change'))
                .blur()
                .then(hasValue('09:30 PM'))
                .then(hasName('blur'))
                .then(hasAltName('change'))
                .then(mouseDown)
                .then(hasValue('09:30 PM'))
                .then(hasName('mouseDown'))
                .then(hasAltName('change'))
                .then(mouseUp)
                .then(hasValue('09:30 PM'))
                .then(hasName('mouseUp'))
                // For normal users this would trigger a 'click' event but for Cypress it doesn't
                .then(hasAltName('change'))
                .click()
                .then(hasValue('09:30 PM'))
                .then(hasName('mouseUp'))
                .then(hasAltName('click'));
        });
    });
}
exports.eventTests = eventTests;
